<div *ngIf="immoconnData">
  <div>Temperaturen:</div>
  <div>
    Vorlauf-Temperatur 1:
    {{ uiHelperService.getTemperatureString(immoconnData.flowTemperatur1) }}
  </div>
  <div>
    Rücklauf-Temperatur 1:
    {{ uiHelperService.getTemperatureString(immoconnData.returnTemperatur1) }}
  </div>
  <div>
    Vorlauf-Temperatur 2:
    {{ uiHelperService.getTemperatureString(immoconnData.flowTemperatur2) }}
  </div>
  <div>
    Rücklauf-Temperatur 2:
    {{ uiHelperService.getTemperatureString(immoconnData.returnTemperatur2) }}
  </div>
  <div>
    Warmwasser-Temperatur 1:
    {{
      uiHelperService.getTemperatureString(immoconnData.warmWaterTemperatur1)
    }}
  </div>
  <div>
    Warmwasser-Temperatur 2:
    {{
      uiHelperService.getTemperatureString(immoconnData.warmWaterTemperatur2)
    }}
  </div>
  <div>
    Außen-Temperatur:
    {{ uiHelperService.getTemperatureString(immoconnData.outTemp) }}
  </div>
  <div>Zustand-Sensoren:</div>
  <div>
    Licht:
    {{ uiHelperService.getSwitchString(immoconnData.light) }}
  </div>
  <div>
    Leckage:
    {{ uiHelperService.getTriggerString(immoconnData.leakage) }}
  </div>
  <div>Kontakte:</div>
  <div>
    Kontakt 1:
    {{ uiHelperService.getTriggerString(immoconnData.shaft1) }}
  </div>
  <div>
    Kontakt 2:
    {{ uiHelperService.getTriggerString(immoconnData.shaft2) }}
  </div>
  <div *ngIf="configData.minPressureText">
    <div>Druck Sensor</div>
    <div>
      Druck:
      {{ uiHelperService.getPressureString(immoconnData.pressure) }}
    </div>
  </div>
  <div>Pumpen:</div>
  <div>
    Pumpe 1 Stromstärke:
    {{ uiHelperService.getRawString(immoconnData.pump1) }}
  </div>
  <div>
    Pumpe 2 Stromstärke:
    {{ uiHelperService.getRawString(immoconnData.pump2) }}
  </div>
  <div>
    Pumpe 3 Stromstärke:
    {{ uiHelperService.getRawString(immoconnData.pump3) }}
  </div>
</div>

<div>Pumpen-Grenzwerte:</div>
<div *ngIf="immoconnData">
  <div *ngIf="configData.pump1Type">
    Grenzwert für Pumpe 1:
    <input [(ngModel)]="configData.pump1OnTreshold" type="number" />
  </div>
  <div *ngIf="configData.pump2Type">
    Grenzwert für Pumpe 2:
    <input [(ngModel)]="configData.pump2OnTreshold" type="number" />
  </div>
  <div *ngIf="configData.pump3Type">
    Grenzwert für Pumpe 3:
    <input [(ngModel)]="configData.pump3OnTreshold" type="number" />
  </div>
  <div *ngIf="configData.pump1OnTreshold">
    Zustand Pumpe 1:
    {{
      uiHelperService.getPumpState(
        configData.pump1OnTreshold,
        immoconnData.pump1
      )
    }}
  </div>
  <div *ngIf="configData.pump2OnTreshold">
    Zustand Pumpe 2:
    {{
      uiHelperService.getPumpState(
        configData.pump2OnTreshold,
        immoconnData.pump2
      )
    }}
  </div>
  <div *ngIf="configData.pump3OnTreshold">
    Zustand Pumpe 3:
    {{
      uiHelperService.getPumpState(
        configData.pump3OnTreshold,
        immoconnData.pump3
      )
    }}
  </div>
</div>
